import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="#D8D8D8" fillRule="evenodd"><path d="M3.03 7.93l2.2 2.88c.31.4.27.97-.09 1.33a.78.78 0 01-1.17-.07l-2.2-2.88c-.31-.4-.27-.97.09-1.33a.78.78 0 011.17.07z" /><path d="M13.48 3.86a.84.84 0 01-.04 1.22l-7.96 7.1a.94.94 0 01-1.29-.04.84.84 0 01.04-1.22l7.95-7.1a.94.94 0 011.3.04z" /></g></svg>);